import { restRequest } from 'plugins/request';
import { QUERY_KEY_AUTH } from './index';
import { getBrowserStorage } from 'plugins/localForage';

const mainStorage = getBrowserStorage();

export const QUERY_KEY_AUTH_DATA = `${QUERY_KEY_AUTH}`;

export const authData = restRequest(QUERY_KEY_AUTH_DATA);

export const apiGetAuthData = async (params = {}) => {
  const auth_key = await mainStorage.getItem('auth_key');

  const defData = { isAuth: false };

  if (!auth_key) return defData;

  const response =
    (await authData.get('', true, false, {
      auth_key,
      hash: 'db5c896a-391c-11dd-90d9-001a92567626',
    })) || {};

  const user = response?.items?.[0] || {};

  return {
    ...defData,
    ...user,
    auth_key,
    isAuth: !!(auth_key && user?.hasOwnProperty?.('username')),
  };
};
